<template>
	<div>
		<div class="login-container" v-show="isLogin">
			<div class="company-link">
				<img
					:src="`${cdnUrl}/static/images/login-circham-001.png`"
				/>
				<div class="corporate-culture">
					<div class="sign">
						<div>全渠道客户服务系统</div>
						<div>Omni-Channel Customer Service System</div>
					</div>
				</div>
			</div>
			<div class="login-form">
				<div class="title-container" v-if="showState !== 'verify'">
					<h3 class="title">
						{{ $t("login.title") }}
					</h3>
					<p class="title-desc">
						{{ $t("login.titleDesc") }}
					</p>
					<!-- <lang-select class="set-language" /> -->
				</div>
				<div v-if="showState === 'normal'">
					<el-form
						ref="loginForm"
						:model="loginForm"
						:rules="loginRules"
						autocomplete="on"
						label-position="left"
					>
						<el-form-item prop="username" class="el-form-back">
							<span class="svg-container">
								<!--<svg-icon icon-class="user" />-->
								{{ $t("login.inputnumber") }}
							</span>
							<el-input
								ref="username"
								v-model="loginForm.username"
								:placeholder="$t('login.username')"
								name="username"
								type="text"
								tabindex="1"
								autocomplete="on"
								maxlength="30"
								@keyup.enter.native="handleLogin"
							/>
						</el-form-item>

						<el-tooltip
							v-model="capsTooltip"
							content="Caps lock is On"
							placement="right"
							manual
						>
							<el-form-item prop="password" class="el-form-back">
								<div class="border-warp">
									<span class="svg-container">
										<!--<svg-icon icon-class="password" />-->
										{{ $t("login.inputpassword") }}
									</span>
									<el-input
										:key="passwordType"
										ref="password"
										v-model="loginForm.password"
										:type="passwordType"
										:placeholder="$t('login.password')"
										maxlength="30"
										name="password"
										tabindex="2"
										@keyup.native="checkCapslock"
										@blur="capsTooltip = false"
										@keyup.enter.native="handleLogin"
									/>
								</div>
								<span class="show-pwd" @click="showPwd">
									<svg-icon
										:icon-class="
											passwordType === 'password'
												? 'eye'
												: 'eye-open'
										"
									/>
								</span>
							</el-form-item>
						</el-tooltip>

						<el-form-item prop="captcha" class="verification-code">
							<div class="border-warp">
								<span class="svg-container">
									{{ $t("login.inpuverification") }}
								</span>
								<el-input
									tabindex="3"
									class="code-input"
									ref="captcha"
									v-model="loginForm.captcha"
									placeholder="请输入验证码"
									name="captcha"
									maxlength="4"
									type="text"
									autocomplete="on"
									@keyup.enter.native="handleLogin"
								/>
								<div class="code-img">
									<img
										:src="`data:image/jpg;base64,${imgUrl}`"
										alt="验证码"
										@click="verificationCodeBtn()"
									/>
								</div>
							</div>
						</el-form-item>

						<el-button
							:loading="loading"
							type="primary"
							style="
								position: absolute;
								left: 35px;
								bottom: 3px;
								width: 450px;
								height: 50px;
							"
							@click.native.prevent="handleLogin"
						>
							{{ $t("login.logIn") }}
						</el-button>
					</el-form>
				</div>
				<div v-if="showState === 'changePwd'">
					<ReplacePwd
						@cancel="showState = 'normal'"
						@handleDone="replaceDone"
					></ReplacePwd>
				</div>
				<div v-if="showState === 'verify'">
					<MFAVerify ref="MFAVerify" @onSuccess="signIn" @onCancel="showState='normal'"/>
				</div>
			</div>
			<el-dialog
				:title="$t('login.thirdparty')"
				:modal-append-to-body="false"
				:visible.sync="showDialog"
			>
				{{ $t("login.thirdpartyTips") }}
				<br />
				<br />
				<br />
				<social-sign />
			</el-dialog>
		</div>

		<div class="login-fot" v-show="isLogin">
			<p class="pain-txt">
				<a
					class="hover-cal"
					target="_blank"
					href="https://beian.miit.gov.cn/"
					>2021-2032 powerd by Majorel 沪ICP备17034586号</a
				>
				<b class="heng-sli">|</b>
				<a
					class="hover-cal"
					target="_blank"
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602005590"
				>
					<span class="tb-footer-mod"
						><img
							:src="`${cdnUrl}/static/images/police.png`"
					/></span>
					沪公网安备 31010602005590号</a
				>
			</p>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { validUsername, valiCaptcha } from "@/utils/validate";
import { getCode } from "@/api/user";
import { menuSelectTree } from "@/api/auth";
import ReplacePwd from "./components/ReplacePwd";
import MFAVerify from "./components/MFAVerify";

export default {
	name: "Login",
	components: {
		ReplacePwd,
		MFAVerify,
	},
	computed: {
		...mapGetters([
			'isLogin',
		])
	},
	data() {
		const validateUsername = (rule, value, callback) => {
			if (!value) {
				callback(new Error("请输入正确的账号"));
			} else {
				callback();
			}
		};
		const validatePassword = (rule, value, callback) => {
			if (!value) {
				callback(new Error("请输入正确的密码"));
			} else {
				callback();
			}
		};
		const validateCaptcha = (rule, value, callback) => {
			if (!value) {
				callback(new Error("请输入正确的验证码"));
			} else {
				callback();
			}
		};
		return {
			cdnUrl: process.env.VUE_APP_BASE_CDN,
			loginForm: {
				username: "",
				password: "",
				captcha: "",
				captchaid: null,
				qrcode: null,
			},
			imgUrl: null,
			loginRules: {
				username: [
					{
						required: true,
						trigger: "blur",
						validator: validateUsername,
					},
				],
				password: [
					{
						required: true,
						trigger: "blur",
						validator: validatePassword,
					},
				],
				captcha: [
					{
						required: true,
						trigger: "blur",
						validator: validateCaptcha,
					},
				],
			},
			passwordType: "password",
			capsTooltip: false,
			loading: false,
			showDialog: false,
			redirect: undefined,
			otherQuery: {},
			// 显示状态
			showState: "normal",
		};
	},
	watch: {
		$route: {
			handler: function (route) {
				const query = route.query;
				if (query) {
					this.redirect = query.redirect;
					this.otherQuery = this.getOtherQuery(query);
				}
			},
			immediate: true,
		},
	},
	created() {
		// window.addEventListener('storage', this.afterQRScan)
	},
	mounted() {
		if (this.loginForm.username === "") {
			this.$refs.username.focus();
		} else if (this.loginForm.password === "") {
			this.$refs.password.focus();
		} else if (this.loginForm.captcha === "") {
			this.$refs.captcha.focus();
		}

		this.verificationCodeBtn();
	},
	destroyed() {
		// window.removeEventListener('storage', this.afterQRScan)
	},
	methods: {
		// 验证码接口
		verificationCodeBtn() {
			getCode()
				.then((res) => {
					let code = res.errcode;
					let data = res.data;
					if (code == 0) {
						this.loginForm.captchaid = data.captchaId;
						this.imgUrl = data.captcha;
					}
				})
				.catch(() => {});
		},
		checkCapslock(e) {
			const { key } = e;
			this.capsTooltip =
				key && key.length === 1 && key >= "A" && key <= "Z";
		},
		showPwd() {
			if (this.passwordType === "password") {
				this.passwordType = "";
			} else {
				this.passwordType = "password";
			}
			this.$nextTick(() => {
				this.$refs.password.focus();
			});
		},
		handleLogin() {
			if (this.loading) return;
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					this.loading = true;
					// console.log(this.loginForm)
					this.$store
						.dispatch("user/login", this.loginForm)
						.then((response) => {
              this.signIn(response);
            })
						.catch(() => {
							this.loginForm.captcha = "";
							// this.$message.error('请正确输入账号信息')
							this.loading = false;
						})
						.finally(() => {
							this.loading = false;
						});
					// 刷新验证码
					this.verificationCodeBtn();

					// setTimeout(() => {
					//   this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
					//   this.loading = false
					// }, 1500)
				} else {
					return false;
				}
			});
		},
		signIn(response) {
			if (response.errcode == 20003) {
				// 90天密码到期
        this.$store.dispatch("user/setToken", {
					access_token: response.data.access_token,
					refresh_token: response.data.refresh_token,
				});
				this.showState = "changePwd";
			} else if (response.data.types) {
				// 须要MFA验证
				console.log(response);
				const { types, bit, key, contactInfo, email } = response.data;
				this.showState = "verify";
				this.$nextTick(() => {
					this.$refs.MFAVerify.init(types, {
						phoneNumber: contactInfo,
						email: email,
						bit,
						key,
					});
				});
			} else {
				// 登录成功
				// this.$store.dispatch('user/changeServiceStatus', this.$t('server.rest'))
        this.$store.dispatch("user/setToken", {
					access_token: response.data.access_token,
					refresh_token: response.data.refresh_token,
				});
				window.location.reload();
				// this.$router
				// 	.push({
				// 		path: this.redirect || "/",
				// 		query: this.otherQuery,
				// 	})
				// 	.catch((err) => {});
				// this.$message.success('登录成功')
				// 登录成功调用菜单接口
			}
		},
		getOtherQuery(query) {
			return Object.keys(query).reduce((acc, cur) => {
				if (cur !== "redirect") {
					acc[cur] = query[cur];
				}
				return acc;
			}, {});
		},
		// afterQRScan() {
		//   if (e.key === 'x-admin-oauth-code') {
		//     const code = getQueryObject(e.newValue)
		//     const codeMap = {
		//       wechat: 'code',
		//       tencent: 'code'
		//     }
		//     const type = codeMap[this.auth_type]
		//     const codeName = code[type]
		//     if (codeName) {
		//       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
		//         this.$router.push({ path: this.redirect || '/' })
		//       })
		//     } else {
		//       alert('第三方登录失败')
		//     }
		//   }
		// }
		replaceDone() {
			this.state = "normal";
			this.loginForm = {
				username: "",
				password: "",
				captcha: "",
				captchaid: null,
				qrcode: null,
			};
		},
	},
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$light_gray: #3c4353;
$cursor: #3c4353;
$black: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
	.login-container .el-input input {
		color: $cursor;
	}
}

/* reset element-ui css */
.login-container {
	.el-form-back,
	.verification-code {
		margin-bottom: 35px;
		.el-input {
			display: inline-block;
			height: 47px;
			input {
				background: transparent;
				-webkit-appearance: none;
				padding: 12px 5px 12px 80px;
				color: $light_gray;
				color: #566980;
				height: 47px;
				caret-color: $black;

				&:-webkit-autofill {
					box-shadow: 0 0 0px 1000px $bg inset !important;
					-webkit-text-fill-color: $cursor !important;
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
$bg: #fff;
$dark_gray: #889aa4;
$light_gray: #3c4353;

.login-fot {
	text-align: center;
	height: 80px;
	.pain-txt {
		.heng-sli {
			margin-left: 10px;
			margin-right: 35px;
		}
		.hover-cal {
			position: relative;
			.tb-footer-mod {
				display: inline-block;
				position: absolute;
				width: 20px;
				height: 20px;
				left: -25px;
			}
		}
		.hover-cal:hover {
			color: red;
		}
	}
}

.login-container {
	height: calc(100vh - 80px);
	width: 100%;
	background-color: $bg;
	overflow-y: scroll;
	text-align: center;
	padding-top: 7%;
	.company-link {
		display: inline-block;
		width: 451px;
		max-width: calc(100% - 70px);
		height: 500px;
		margin: 0 35px 0;
		/*border: 1px solid #999;*/
		box-sizing: border-box;
		background: #f7f8fc;
		border-radius: 4px;
		img {
			display: block;
			width: 100%;
			margin-top: 25px;
		}
		.corporate-culture {
			margin-top: 30px;
			width: 100%;
			display: table;
			height: 130px;
			padding: 20px;
			.sign {
				display: flex;
				flex-direction: column;
				align-items: center;
				& > div:nth-child(1) {
					width: 264px;
					height: 36px;
					font-size: 26px;
					font-weight: 500;
					color: #566980;
					line-height: 36px;
					letter-spacing: 3px;
					position: relative;
					&::before {
						width: 57px;
						height: 1px;
						content: "";
						position: absolute;
						top: 50%;
						left: calc(-57px - 16px);
						background: #d4d4d4;
					}
					&::after {
						width: 57px;
						height: 1px;
						content: "";
						position: absolute;
						top: 50%;
						right: calc(-57px - 16px);
						background: #d4d4d4;
					}
				}
				& > div:nth-child(2) {
					width: 275px;
					height: 28px;
					font-size: 14px;
					font-weight: 400;
					color: #6c7e91;
					line-height: 28px;
				}
			}
		}
	}
	.login-form {
		display: inline-block;
		position: relative;
		width: 520px;
		max-width: 100%;
		height: 500px;
		padding: 0 35px 0;
		// margin: 0 auto;
		overflow: hidden;
	}

	.tips {
		font-size: 14px;
		color: #3c4353;
		margin-bottom: 10px;

		span {
			&:first-of-type {
				margin-right: 16px;
			}
		}
	}

	.svg-container {
		z-index: 1;
		padding: 6px 5px 6px 15px;
		color: $light_gray;
		vertical-align: middle;
		width: 67px;
		display: inline-block;
		position: absolute;
	}

	.title-container {
		position: relative;

		.title {
			font-size: 26px;
			color: $light_gray;
			margin: 0px auto 10px auto;
			text-align: left;
			font-weight: bold;
		}

		.title-desc {
			font-size: 14px;
			color: rgba(60, 67, 83, 0.76);
			margin: 0px auto 60px auto;
			text-align: left;
			font-weight: bold;
		}

		.set-language {
			color: #fff;
			position: absolute;
			top: 3px;
			font-size: 18px;
			right: 0px;
			cursor: pointer;
		}
	}

	.verification-code {
		background: #ffffff;
		.border-warp {
			display: flex;
			justify-content: space-between;
			.code-input {
				/*border: 1px solid #D8D8D8;*/
				border-radius: 4px;
				width: 250px;
				height: 50px;
			}
			.code-img {
				width: 154px;
				height: 50px;
				background: #ffffff;
				border-radius: 4px;
				cursor: pointer;
				text-align: right;
				img {
					width: 120px;
					height: 48px;
					border-right: 4px;
					border-radius: 4px;
					border: 1px solid #337eff;
				}
			}
		}
	}
	.show-pwd {
		position: absolute;
		right: 10px;
		top: 7px;
		font-size: 16px;
		color: $dark_gray;
		cursor: pointer;
		user-select: none;
	}

	.thirdparty-button {
		position: absolute;
		right: 0;
		bottom: 6px;
	}

	@media only screen and (max-width: 470px) {
		.thirdparty-button {
			display: none;
		}
	}
}
</style>
